import { render } from "./Testimonies.vue?vue&type=template&id=15d42577&scoped=true"
import script from "./Testimonies.vue?vue&type=script&lang=js"
export * from "./Testimonies.vue?vue&type=script&lang=js"

import "./Testimonies.vue?vue&type=style&index=0&id=15d42577&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-15d42577"

export default script

/* vue-cli-plugin-import-components */
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import PageTitle from "@/components/PageTitle.vue";
import BaseButton from "@/components/BaseButton.vue";
import BaseIcon from "@/components/BaseIcon.vue";
import TestimonyModal from "@/components/TestimonyModal.vue";
import BaseConfirmModal from "@/components/BaseConfirmModal.vue";
script.components = Object.assign({}, { Breadcrumbs, PageTitle, BaseButton, BaseIcon, TestimonyModal, BaseConfirmModal }, script.components);